export type AppTheme = 'light' | 'dark';

const THEME_KEY = 'lk-meet-theme';
export const APP_THEME_EVENT = 'lk-meet-theme';

export function loadAppTheme(): AppTheme {
  if (typeof window === 'undefined') return 'light';
  try {
    return window.localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyAppTheme(theme: AppTheme) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
}

export function saveAppTheme(theme: AppTheme) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(THEME_KEY, theme);
  applyAppTheme(theme);
  window.dispatchEvent(new Event(APP_THEME_EVENT));
}

export function toggleAppTheme(): AppTheme {
  const next = loadAppTheme() === 'dark' ? 'light' : 'dark';
  saveAppTheme(next);
  return next;
}

export function subscribeAppTheme(listener: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(APP_THEME_EVENT, listener);
  return () => window.removeEventListener(APP_THEME_EVENT, listener);
}
